import { dominioEmpresaBeneficios, dominioEmpresaBeneficiosConviteHome, dominioEmpresaBeneficiosConviteHomeWebp, dominioEmpresaBeneficiosWebp, dominioEmpresaCobrancas, dominioEmpresaCobrancasWebp, dominioEmpresaContabilidadeContratacao, dominioEmpresaContabilidadeContratacaoWebp, dominioEmpresaContabilidadeDigital, dominioEmpresaContabilidadeDigitalWebp, dominioEmpresaContaPj, dominioEmpresaContaPjConviteHome, dominioEmpresaContaPjConviteHomeWebp, dominioEmpresaContaPjWebp, dominioEscritorioBeneficios, dominioEscritorioBeneficiosWebp, dominioEscritorioCobrancas, dominioEscritorioCobrancasWebp, dominioEscritorioContabilidadeConviteHome, dominioEscritorioContabilidadeConviteHomeWebp, dominioEscritorioContabilidadeDigital, dominioEscritorioContabilidadeDigitalWebp, dominioEscritorioContaPj, dominioEscritorioContaPjWebp, dominioEscritorioProgramaFidelidade, dominioEscritorioProgramaFidelidadeWebp, dominioEscritorioSynergy, } from '@ibk/shared-assets';
import { ProductAlias } from '@ibk/shared-types';
export const PRODUCT_BANNER_CONFIGS = {
    [ProductAlias.CONTA_DIGITAL]: {
        id: 'conta-pj-banner',
        productAlias: ProductAlias.CONTA_DIGITAL,
        images: {
            empresa: {
                png: dominioEmpresaContaPj,
                webp: dominioEmpresaContaPjWebp,
            },
            escritorio: {
                png: dominioEscritorioContaPj,
                webp: dominioEscritorioContaPjWebp,
            },
        },
        priority: 1,
    },
    [ProductAlias.COBRANCAS]: {
        id: 'cobrancas-banner',
        productAlias: ProductAlias.COBRANCAS,
        images: {
            empresa: {
                png: dominioEmpresaCobrancas,
                webp: dominioEmpresaCobrancasWebp,
            },
            escritorio: {
                png: dominioEscritorioCobrancas,
                webp: dominioEscritorioCobrancasWebp,
            },
        },
        priority: 2,
    },
    [ProductAlias.CONTABILIDADE_DIGITAL]: {
        id: 'contabilidade-digital-banner',
        productAlias: ProductAlias.CONTABILIDADE_DIGITAL,
        images: {
            empresa: {
                png: dominioEmpresaContabilidadeDigital,
                webp: dominioEmpresaContabilidadeDigitalWebp,
            },
            escritorio: {
                png: dominioEscritorioContabilidadeDigital,
                webp: dominioEscritorioContabilidadeDigitalWebp,
            },
        },
        priority: 3,
    },
    [ProductAlias.BENEFICIOS]: {
        id: 'beneficios-banner',
        productAlias: ProductAlias.BENEFICIOS,
        images: {
            empresa: {
                png: dominioEmpresaBeneficios,
                webp: dominioEmpresaBeneficiosWebp,
            },
            escritorio: {
                png: dominioEscritorioBeneficios,
                webp: dominioEscritorioBeneficiosWebp,
            },
        },
        priority: 4,
    },
    [ProductAlias.DOMINIO_RECOMPENSAS]: {
        id: 'fidelity-program-banner',
        productAlias: ProductAlias.DOMINIO_RECOMPENSAS,
        images: {
            empresa: {
                png: dominioEscritorioProgramaFidelidade,
                webp: dominioEscritorioProgramaFidelidadeWebp,
            },
            escritorio: {
                png: dominioEscritorioProgramaFidelidade,
                webp: dominioEscritorioProgramaFidelidadeWebp,
            },
        },
        priority: 5,
    },
};
export const CONTA_PJ_CONVITE_BANNER_CONFIG = {
    id: 'conta-pj-convite-banner',
    productAlias: ProductAlias.CONTA_DIGITAL,
    images: {
        empresa: {
            png: dominioEmpresaContaPjConviteHome,
            webp: dominioEmpresaContaPjConviteHomeWebp,
        },
        escritorio: {
            png: dominioEmpresaContaPjConviteHome,
            webp: dominioEmpresaContaPjConviteHomeWebp,
        },
    },
    priority: 1,
};
export const BENEFICIOS_CONVITE_BANNER_CONFIG = {
    id: 'beneficios-convite-banner',
    productAlias: ProductAlias.BENEFICIOS,
    images: {
        empresa: {
            png: dominioEmpresaBeneficiosConviteHome,
            webp: dominioEmpresaBeneficiosConviteHomeWebp,
        },
        escritorio: {
            png: dominioEmpresaBeneficiosConviteHome,
            webp: dominioEmpresaBeneficiosConviteHomeWebp,
        },
    },
    priority: 4,
};
export const SYNERGY_BANNER_CONFIG = {
    id: 'synergy-banner',
    productAlias: ProductAlias.BENEFICIOS,
    images: {
        empresa: {
            png: dominioEscritorioSynergy,
            webp: dominioEscritorioSynergy,
        },
        escritorio: {
            png: dominioEscritorioSynergy,
            webp: dominioEscritorioSynergy,
        },
    },
    priority: 6,
};
export const CONTABILIDADE_CONVITE_BANNER_CONFIG = {
    id: 'contabilidade-digital-convite-banner',
    productAlias: ProductAlias.CONTABILIDADE_DIGITAL,
    images: {
        empresa: {
            png: dominioEmpresaContabilidadeContratacao,
            webp: dominioEmpresaContabilidadeContratacaoWebp,
        },
        escritorio: {
            png: dominioEscritorioContabilidadeConviteHome,
            webp: dominioEscritorioContabilidadeConviteHomeWebp,
        },
    },
    priority: 3,
};
export const getBannerConfig = (productAlias) => {
    return PRODUCT_BANNER_CONFIGS[productAlias];
};
export const getAllBannerConfigs = () => {
    return Object.values(PRODUCT_BANNER_CONFIGS).sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));
};
